// extracted by mini-css-extract-plugin
module.exports = {"logout":"Logout_logout__2YPyQ","logoutBtn":"Logout_logoutBtn__24YCb"};